import { Spin, Table } from 'antd';

import type { ModelWarehouseInventory } from '@app/api/WarehouseInventories';
import { useWindowSize } from '@app/hooks';
import { PF } from '@app/pages/Warehouses/Inventory/data';
import type { InventoryTableType } from '@app/pages/Warehouses/Inventory/types';

const TABLE = `${PF}_table`;

export const InventoryTable: InventoryTableType = ({
  columns,
  data,
  total,
  filters: { Page, ItemsPerPage },
  range: { from, to },
  handlePaginationChange,
  isPageLoading = false,
}) => {
  const { isMobile } = useWindowSize();

  if (isPageLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${TABLE}_container`}>
      <div className={`${TABLE}_content`}>
        <Table<ModelWarehouseInventory>
          columns={columns}
          dataSource={data}
          rowKey={({ Id }) => Id}
          pagination={
            total > 0
              ? {
                  responsive: true,
                  current: Page,
                  total,
                  pageSize: ItemsPerPage,
                  showSizeChanger: true,
                  showLessItems: isMobile,
                  size: isMobile ? 'small' : 'default',
                  position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
                  onChange: (page, pageSize) =>
                    handlePaginationChange({ page, pageSize }),
                  onShowSizeChange: (_, pageSize) =>
                    handlePaginationChange({ page: 1, pageSize }),
                  showTotal: (itemsTotal) =>
                    isMobile
                      ? `Всего ${itemsTotal}`
                      : `Показаны результаты с ${from} по ${to} из ${itemsTotal}`,
                }
              : false
          }
          size={isMobile ? 'small' : 'middle'}
          scroll={{ x: 1176 }}
          className={`${TABLE}_grid`}
        />
      </div>
    </div>
  );
};
